module.exports = __webpack_public_path__ + "dist/onlineServiceBg.af56cbeb.png";